
import { defineComponent, PropType } from 'vue'
import { AppButton } from '@shared/ui'

interface IChoosenBank {
  schemaPrefix: string
  email: string
}
export default defineComponent({
  name: 'PaymentWithoutDiscountModal',

  components: { AppButton },

  props: {
    totalSum: {
      type: String as PropType<string>,
      required: false,
      default: '0'
    },
    tips: {
      type: String as PropType<string>,
      required: false,
      default: '0'
    },
    currencyIcon: {
      type: String as PropType<string>,
      required: false,
      default: ''
    },
    choosenBank: {
      type: Object as PropType<IChoosenBank | null>,
      required: false,
      default: () => {}
    }
  },
  emits: ['onPaymentWithoutDiscount', 'pay', 'togglePreloader'],

  computed: {
    sumTotalSum (): string {
      return (parseFloat(this.totalSum) + parseFloat(this.tips)).toFixed(2)
    }
  },
  methods: {
    // Продолжить оплату без скидки
    pay (): void {
      this.$emit('pay', this.choosenBank, true) // Выполняем payCard() и передаем выбранный банк для оплаты (СБП) (если не СБП, то choosenBank === null) и флаг что не ждём скидку
      this.$emit('onPaymentWithoutDiscount') // Закрываем модалку
    },

    // Ждать скидку
    waitDiscount (): void {
      this.$emit('togglePreloader')
      this.$emit('onPaymentWithoutDiscount')
    }
  }
})
